export const fkmxFormatId = string => {
  if (!string) return '';
  return string
    .toLowerCase()
    .split(' ')
    .join('-');
};

const formatNumber = num => Math.round((num + Number.EPSILON) * 100) / 100;

const formatAdditionalInfo = item => {
  const keys = [
    // "image2",
    // "image3",
    // "image4",
    'sloganTitle',
    'sloganSubtitle',
    'sloganText1',
    'sloganText2',
    'sloganText3',
    'descriptionAdditionalTitle',
    'descriptionAdditionalSubtitle',
    'mediaPresentation',
    // "mediaPresentationVideo",
    'mediaDescriptionTitle',
    'mediaDescriptionSubtitle',
    'banner',
    'beneficialEffectTitle',
    'beneficialEffectSubtitle',
    'icon1',
    'icon2',
    'icon3',
    'iconDescription1',
    'iconDescription2',
    'iconDescription3',
    'additionalInfo1',
    'additionalInfo2',
    'additionalInfo3',
    'additionalInfo4',
  ];
  const totals = keys.reduce((acc, curr) => {
    return acc + (!!item[curr] ? 1 : 0);
  }, 0);
  if (!totals) return { hasAdditionalInfo: false };
  return {
    has_additional_info: totals > 0,
    additional_info_completeness_percentage: formatNumber(
      (totals / keys.length) * 100
    ),
    has_video: !!item.mediaPresentationVideo,
    has_more_images: !!item.image2 || !!item.image2 || !!item.image2,
  };
};

const formatItem = (item, index, list) => {
  let obj = {
    id: item.id,
    name: item.name,

    currency: 'EUR',
    price: formatNumber(item.price), // TODO: google lo legge in milioni, capire se ok
    discount: formatNumber((item.listPrice || item.price) - item.price), // TODO: non appare in analytics
    quantity: item.quantity || 1,

    ean: item.eanCode,
    minsan: item.minsanCode,

    brand: item.brand,
    category_first: item.type,
    category_second: item.categoryName,
    category_third: item.subcategoryName,

    stock: item.stock,
    sell_if_out_of_stock: item.sellIfOutOfStock,
    max_num_in_cart: item.maxNumInCart,
    min_num_in_cart: item.minNumInCart,

    ...formatAdditionalInfo(item),

    // location_id: "L_12345", // TODO: cosa sarebbe ?
    // affiliation: "Google Merchandise Store", // TODO: cosa sarebbe ?
  };

  if (list) {
    obj = {
      ...obj,
      index,
      item_list_id: fkmxFormatId(list.id),
      item_list_name: list.name,
    };
  }

  return obj;
};

export function fkmxViewItemList(products = [], listInfo) {
  try {
    if (!!window.fkmx_add_event && !!listInfo) {
      window.fkmx_add_event('view_item_list', {
        item_list_id: fkmxFormatId(listInfo.id),
        item_list_name: listInfo.name,
        items: products.map((product, index) =>
          formatItem(product, index, listInfo)
        ),
      });
    }
  } catch (err) {
    console.error('Farmakom Metrics Error', err);
  }
}

export function fkmxSelectItem(product, listInfo) {
  try {
    if (!!window.fkmx_add_event && !!product && !!listInfo) {
      window.fkmx_add_event('select_item', {
        item_list_id: fkmxFormatId(listInfo.id),
        item_list_name: listInfo.name,
        items: [formatItem(product, 0, listInfo)],
      });
    }
  } catch (err) {
    console.error('Farmakom Metrics Error', err);
  }
}

export function fkmxViewItem(product) {
  try {
    if (!!window.fkmx_add_event && !!product) {
      window.fkmx_add_event('view_item', {
        currency: 'EUR',
        value: product.price,
        items: [formatItem(product)],
      });
    }
  } catch (err) {
    console.error('Farmakom Metrics Error', err);
  }
}

export function fkmxViewPromotions(banners) {
  try {
    if (!!window.fkmx_add_event && !!banners && !!banners.length) {
      window.fkmx_add_event('view_promotions', {
        item_list_id: fkmxFormatId(banners[0].homePosition),
        item_list_name: banners[0].homePosition,
        items: banners.map(banner => ({
          creative_slot: banner.homePosition,
          creative_name: banner.name,
          promotion_id: banner.id,
          promotion_name: banner.seoName,
        })),
      });
    }
  } catch (err) {
    console.error('Farmakom Metrics Error', err);
  }
}

export function fkmxSelectPromotion(banner) {
  try {
    if (!!window.fkmx_add_event && !!banner) {
      window.fkmx_add_event('select_promotion', {
        item_list_id: fkmxFormatId(banner.homePosition),
        item_list_name: banner.homePosition,
        items: [
          {
            creative_name: banner.name,
            creative_slot: banner.homePosition,
            promotion_id: banner.id,
            promotion_name: banner.seoName,
          },
        ],
      });
    }
  } catch (err) {
    console.error('Farmakom Metrics Error', err);
  }
}

export function fkmxAddToCart(product, listInfo) {
  try {
    if (!!window.fkmx_add_event && !!product) {
      window.fkmx_add_event('add_to_cart', {
        currency: 'EUR',
        value: product.price,
        items: [formatItem(product, 0, listInfo)],
      });
    }
  } catch (err) {
    console.error('Farmakom Metrics Error', err);
  }
}

export function fkmxRemoveFromCart(product) {
  try {
    if (!!window.fkmx_add_event && !!product) {
      window.fkmx_add_event('remove_from_cart', {
        currency: 'EUR',
        value: product.price,
        items: [formatItem(product, 0)],
      });
    }
  } catch (err) {
    console.error('Farmakom Metrics Error', err);
  }
}

export function fkmxViewCart(products = [], value = 0) {
  try {
    if (!!window.fkmx_add_event) {
      window.fkmx_add_event('view_cart', {
        currency: 'EUR',
        value,
        items: products.map((product, index) => formatItem(product, index)),
      });
    }
  } catch (err) {
    console.error('Farmakom Metrics Error', err);
  }
}

export function fkmxBeginCheckout(products = [], value = 0) {
  try {
    if (!!window.fkmx_add_event) {
      window.fkmx_add_event('begin_checkout', {
        currency: 'EUR',
        value,
        items: products.map((product, index) => formatItem(product, index)),

        // TODO: gestire coupon
      });
    }
  } catch (err) {
    console.error('Farmakom Metrics Error', err);
  }
}

export function fkmxAddShippingInfo(products = [], value = 0, shippingInfo) {
  try {
    if (!!window.fkmx_add_event && !!shippingInfo) {
      window.fkmx_add_event('add_shipping_info', {
        currency: 'EUR',
        value,
        items: products.map((product, index) => formatItem(product, index)),
        shipping_type: shippingInfo.type,
        shipping_cost: shippingInfo.cost,
        shipping_with_pudo: shippingInfo.withPudo,
      });
    }
  } catch (err) {
    console.error('Farmakom Metrics Error', err);
  }
}

export function fkmxAddPaymentInfo(products = [], value = 0, paymentInfo) {
  try {
    if (!!window.fkmx_add_event && !!paymentInfo) {
      window.fkmx_add_event('add_payment_info', {
        currency: 'EUR',
        value,
        items: products.map((product, index) => formatItem(product, index)),
        payment_type: paymentInfo.type,
        payment_cost: paymentInfo.cost,
      });
    }
  } catch (err) {
    console.error('Farmakom Metrics Error', err);
  }
}

export function fkmxPurchase(order) {
  try {
    if (!!window.fkmx_add_event && !!order) {
      window.fkmx_add_event('purchase', {
        transaction_id: order.id,
        currency: 'EUR',
        value: order.revenue,
        shipping: order.shipping,
        tax: order.tax,
        coupon: order.coupon,
        items: order.items.map((product, index) => formatItem(product, index)),

        // TODO: gestire coupon
      });
    }
  } catch (err) {
    console.error('Farmakom Metrics Error', err);
  }
}

export function fkmxSearch(search_term = '') {
  try {
    if (!!window.fkmx_add_event) {
      window.fkmx_add_event('search', {
        search_term,
      });
    }
  } catch (err) {
    console.error('Farmakom Metrics Error', err);
  }
}

export function fkmxLogin(user) {
  try {
    if (!!window.fkmx_add_event) {
      window.fkmx_add_event('login', {
        user,
      });
    }
  } catch (err) {
    console.error('Farmakom Metrics Error', err);
  }
}

export function fkmxSignup(user) {
  try {
    if (!!window.fkmx_add_event) {
      window.fkmx_add_event('signup', {
        user,
      });
    }
  } catch (err) {
    console.error('Farmakom Metrics Error', err);
  }
}
